module.exports = __webpack_public_path__ + "static/media/bolso (8).537c961b.jpg";